module.exports = __webpack_public_path__ + "img/module-academy.21fcb872.svg";